<template>
  <div>
     <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card>
          <v-card color="#434343" class="mx-auto">
            <v-layout justify-start wrap pt-5>
              <v-flex xs12 sm6 md6>
                <v-card-text>
                  <v-flex xs12 sm12 md8 lg6 text-center>
                    <span
                      style="
                        color: #ffba00;
                        font-family: nunitosansbold;
                        font-size: 18px;
                      "
                      >Students Count</span
                    >
                  </v-flex>
                </v-card-text>
                <v-layout justify-start wrap pt-5>
                  <v-flex xs6 sm6 md4>
                    <v-layout justify-center wrap>
                      <v-flex xs8 text-cenetr>
                        <span class="total1">Total Students</span>
                      </v-flex>
                      <v-flex xs8 text-left v-if="attendence.TotalStudents">
                        <span
                          style="
                            color: white;
                            font-family: nunitosansextrabold;
                            font-size: 28px;
                          "
                          >{{ attendence.TotalStudents }}</span
                        >
                      </v-flex>
                      <v-flex xs8 text-left v-else>
                        <span
                          style="
                            color: white;
                            font-family: nunitosansextrabold;
                            font-size: 28px;
                          "
                          >0</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout justify-start wrap py-5>
                  <v-flex xs6 sm6 md4>
                    <v-layout justify-center wrap>
                      <v-flex xs8 text-left>
                        <span class="total1">Total Boys</span>
                      </v-flex>
                      <v-flex xs8 text-left v-if="attendence.boys">
                        <span
                          style="
                            color: white;
                            font-family: nunitosanssemibold;
                            font-size: 28px;
                          "
                          >{{ attendence.boys }}</span
                        >
                      </v-flex>
                      <v-flex xs8 text-left v-else>
                        <span
                          style="
                            color: white;
                            font-family: nunitosanssemibold;
                            font-size: 28px;
                          "
                          >0</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md4>
                    <v-layout justify-center wrap>
                      <v-flex xs12>
                        <span class="total1">Total Girls</span>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-center wrap>
                      <v-flex xs12 v-if="attendence.girls">
                        <span
                          style="
                            color: white;
                            font-family: nunitosanssemibold;
                            font-size: 28px;
                          "
                          >{{ attendence.girls }}</span
                        >
                      </v-flex>
                      <v-flex xs12 v-else>
                        <span
                          style="
                            color: white;
                            font-family: nunitosanssemibold;
                            font-size: 28px;
                          "
                          >0</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6 px-2 pr-md-7 pt-3 pb-6>
                <v-card dark color="#474747" rounded="lg">
                  <v-layout justify-center wrap pb-5>
                    <v-flex xs12 sm7 md7>
                      <v-card-text>
                        <span
                          style="font-family: nunitosansbold; font-size: 13px"
                          >Todays School Attendance Report</span
                        ><br />
                        <span
                          style="
                            color: #f7f7f7;
                            font-family: nunitosansbold;
                            font-size: 13px;
                          "
                          >{{ currentMonth }}</span
                        >
                        <v-layout justify-start wrap py-7>
                          <v-flex xs6 sm4 md6 lg5>
                            <v-layout wrap>
                              <v-flex xs8>
                                <span
                                  style="
                                    color: #ffba00;
                                    font-family: nunitosansregular;
                                    font-size: 13px;
                                  "
                                  >Present</span
                                >
                              </v-flex>
                              <v-flex xs8 v-if="attendence.presentCount">
                                <span
                                  style="
                                    font-family: nunitosanssemibold;
                                    font-size: 20px;
                                  "
                                  >{{ attendence.presentCount }}</span
                                >
                              </v-flex>
                              <v-flex xs8 v-else>
                                <span
                                  style="
                                    font-family: nunitosanssemibold;
                                    font-size: 20px;
                                  "
                                  >0</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs6 sm4 md5 text-center>
                            <span
                              style="
                                color: #f43737;
                                font-family: nunitosansregular;
                                font-size: 13px;
                              "
                              >Absent</span
                            ><br />
                            <span
                              v-if="attendence.absenteesCount"
                              style="
                                font-family: nunitosanssemibold;
                                font-size: 20px;
                              "
                              >{{ attendence.absenteesCount }}</span
                            >
                            <span
                              v-else
                              style="
                                font-family: nunitosanssemibold;
                                font-size: 20px;
                              "
                              >0</span
                            >
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-flex>
                    <v-flex xs12 sm4 md4 pt-8 text-center>
                      <v-progress-circular
                        :size="65"
                        :width="5"
                        :value="attendence.percent"
                        color="#FFBA00"
                      >
                        <span
                          v-if="attendence.percent"
                          style="color: #ffffff; font-size: 12px"
                          >{{ attendence.percent }}</span
                        >
                        <span v-else style="color: #ffffff; font-size: 12px"
                          >0</span
                        >
                      </v-progress-circular>
                      <v-flex text-center xs12 sm12 md12 py-2>
                        <span
                          style="
                            color: #ffba00;
                            font-family: nunitosansregular;
                            font-size: 13px;
                          "
                          >Todays Attendance Percentage</span
                        >
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
          <v-card-text>
            <v-layout justify-start wrap pa-2>
              <v-flex xs12 sm6 md3 lg3>
                <span style="color: #000000; font-family: nunitosansbold"
                  >Todays Absentees Report</span
                >
              </v-flex>
              <v-flex xs7 sm8 md6 lg6>
                <span style="color: #e63737; font-family: nunitosanssemibold"
                  >{{absent}} Overall Absentess</span
                >
              </v-flex>
              <v-flex xs5 sm4 md2 lg2 offset-md1>
                <v-layout justify-end wrap>
                  <v-flex xs11 sm8 md8 text-right>
                    <span
                      style="
                        color: #606060;
                        font-family: nunitosansregular;
                        font-size: 12px;
                      "
                      >Download</span
                    >
                  </v-flex>
                  <v-flex xs1 sm1 md1  text-right>
                    <v-icon
                      style="
                        color: #606060;
                        font-family: nunitosansregular;
                        font-size: 16px;
                      "
                      >mdi-download-outline</v-icon
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout justify-center wrap v-if="details.length>0">
              <v-flex xs12 v-for="(item, i) in details" :key="i" pa-2>
                <v-card outlined>
                  <v-card-text>
                    <v-layout justify-start wrap>
                      <v-flex xs6 sm6 md3 lg1>
                        <span
                          style="color: #000000; font-family: nunitosansbold"
                          >Class {{ item.standard.standardName }}</span
                        >
                      </v-flex>
                      <v-flex xs6 sm6 md3 lg11>
                        <span
                          style="
                            color: #e63737;
                            font-family: nunitosanssemibold;
                          "
                          >{{ item.absentcount }} Absentees</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout justify-start wrap>
                      <v-flex xs12 v-for="list in item.data" :key="list.index">
                        <v-layout justify-start wrap pt-5>
                          <v-flex xs3 sm2 md2 lg1>
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosansbold;
                              "
                              >{{ list.class.className }}</span
                            >
                          </v-flex>
                          <v-flex xs2 sm2 md2 lg1>
                            <v-btn
                              small
                              width="25"
                              height="25"
                              outlined
                              fab
                              color="#E63737"
                              >{{ list.absentcount }}</v-btn
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout
                          justify-start
                          wrap
                          v-for="list1 in list.data"
                          :key="list1.index"
                        >
                          <v-flex
                            xs12
                            sm6
                            md4
                            pt-2
                            align-self-start
                            v-for="list2 in list1.absentees"
                            :key="list2.index"
                          >
                            <v-layout justify-start wrap>
                              <v-flex xs4 sm2 md2 lg3 pt-2 text-left>
                                <span
                                  style="
                                    font-family: nunitosanssemibold;
                                    color: #9d9d9d;
                                  "
                                  >{{ list2.admissionnumber }}</span
                                >
                              </v-flex>
                              <v-flex xs3 sm4 md4 lg3 text-left>
                                <v-avatar style="cursor: pointer" size="40">
                                  <v-img :src="mediaURL + list2.user.photo" />
                                </v-avatar>
                              </v-flex>
                              <v-flex xs5 sm5 md5 lg5 pt-2>
                                <router-link
                                  :to="'/studentDetails/' + list2._id"
                                  style="text-decoration: none"
                                >
                                  <span
                                    style="
                                      font-family: nunitosansregular;
                                      color: #000000;
                                    "
                                    >{{ list2.user.name }}</span
                                  >
                                </router-link>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      attendence: [],
      details: [],
      absent:[],
      appLoading: false,
      ServerError: false,
      currentMonth: "",
      list: [
        {
          no: "1",
          pic: require("../../assets/images/Group 281.png"),
          name: "Alex Mathew",
        },
        {
          no: "2",
          pic: require("../../assets/images/Group 281.png"),
          name: "Alex Mathew",
        },
        {
          no: "3",
          pic: require("../../assets/images/Group 281.png"),
          name: "Alex Mathew",
        },
      ],
    };
  },
  beforeMount() {
    let ndate = new Date().toISOString().substr(5, 2);
    var month = new Array();
    month["01"] = "January";
    month["02"] = "February";
    month["03"] = "March";
    month["04"] = "April";
    month["05"] = "May";
    month["06"] = "June";
    month["07"] = "July";
    month["08"] = "August";
    month["09"] = "September";
    month["10"] = "October";
    month["11"] = "November";
    month["12"] = "December";
    this.currentMonth = month[ndate];
    // console.log(this.currentMonth)
  },
  mounted() {
    this.getData();
    this.getDetails();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/attendance/adminget",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          date: this.date,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.attendence = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getDetails() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/attendance/standard/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          date: this.date,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.details = response.data.data;
          this.absent=response.data.absentCount
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.total1 {
  color: #ffffff;
  font-family: futurabook;
  font-size: 13px;
}
</style>